import { render, staticRenderFns } from "./GifLoading.vue?vue&type=template&id=5d4756c6&scoped=true&"
import script from "./GifLoading.vue?vue&type=script&lang=js&"
export * from "./GifLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4756c6",
  null
  
)

export default component.exports